
export default {
	order: {
	},

	summary: {
		subtotal: 0,
		total: 0,
		taxes: [],
	},

	cartItems: [],
}